<template>
  <el-dialog
    class="dialog-leave-apply"
    :title="renderData.name"
    :visible.sync="dialogShow"
    :before-close="handleBeforeClose"
    width="630px"
  >
    <div class="content">
      <div class="title mb-20">公文信息</div>
      <el-form
        class="g-form-grid mt-10"
        @keyup.enter.native="submitForm('form')"
        :model="form"
        :rules="rules"
        ref="form"
        :label-width="renderData.fieldsLabelWidth || '110px'"
      >
        <!-- 非附件 -->
        <div v-for="(item, index) in renderData.fields" :key="index">
          <cmpFormItem
            v-if="item.type !== 'file' && item.type !== 'date-list'"
            :itemData="item"
            :configOptions="configOptions"
            :form="form"
            :remoteFileList="remoteFileList"
            :isDisable="item.isDisable"
            @changeTimeMul="changeTimeMul"
            @changeHolidayType="changeHolidayType"
            @fujian="fujian"
            @callFunDisable="callFunDisable"
            @callFunOther="callFunOther"
            @eventChecker="eventChecker"
          ></cmpFormItem>
        </div>

        <!-- 明细列表 -->
        <cmpFormList
          ref="cmpFormList"
          :detailObj="renderData.detail"
          @setCalc="setCalc"
          v-if="renderData.detail && renderData.detail.length"
        ></cmpFormList>

        <!-- 附件 -->
        <div class="title mb-20 noborder">公文附件</div>
        <div
          v-for="(item, index) in renderData.fields"
          :key="'fujian-' + index"
        >
          <cmpFormItem
            v-if="item.type === 'file'"
            :itemData="item"
            :configOptions="configOptions"
            :form="form"
            :remoteFileList="remoteFileList"
            @changeTimeMul="changeTimeMul"
            @changeHolidayType="changeHolidayType"
            @fujian="fujian"
            @eventChecker="eventChecker"
          ></cmpFormItem>
        </div>

        <div class="title mb-20">处理意见</div>
        <!-- <el-form-item label="学生姓名 :" prop="realName">
          <el-input v-model="form.realName" placeholder="请输入"></el-input>
        </el-form-item> -->
        <el-form-item label="选择阅办人" prop="currentApproval">
          <el-select v-model="form.currentApproval" clearable filterable placeholder="请选择">
            <el-option
              v-for="item in personList"
              :key="item.userId"
              :label="item.name"
              :value="item.userId"
            ></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="处理意见" prop="ext1">
          <el-input v-model="form.ext1" type="textarea" placeholder="请输入"></el-input>
        </el-form-item>

        <!-- <el-form-item label="选择抄送人" prop="yueban">
          <el-select v-model="form.yueban" clearable multiple filterable placeholder="请选择">
            <el-option
              v-for="item in personList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item> -->


        <!-- 下面todo delel -->
        <div class="title mb-20" style="display: none;">处理流</div>
        <div class="time-line-wrap" style="display: none;">
          <el-timeline>
            <el-timeline-item v-for="(item, index) in approval" :key="index">
              <h3 class="mb-10">
                {{ item.type === 1 ? '处理人' : '抄送人' }}
                <!-- <el-tag
                  size="mini"
                  v-if="
                    item.examineMode === 1 &&
                      item.nodeUserList &&
                      item.nodeUserList.length > 1
                  "
                  >或签</el-tag
                >
                <el-tag size="mini" v-if="item.examineMode === 2">会签</el-tag> -->
              </h3>
              <div
                class="timeline-box"
                v-for="(it, i) in item.nodeUserList"
                :key="i"
              >
                <img
                  class="g-pic mini mr-10"
                  :src="it.userImage || ''"
                  alt
                  :onerror="defaultHeadImg"
                />
                <div class="timeline-content">
                  <div class="name-box m-assist">
                    <div>
                      <span class="mr-10">{{ it.name }}</span>
  
                      <span class="ml-20">辽宁省博物馆馆长</span>
                    </div>
                    <span class="date fr ml-20">2024-06-12</span>
                    <!-- 0 发起申请 1 审批中 2 已同意 6 审批通过 3 审批拒绝 4 已撤销 -->
                    <!-- <span
                      :class="{'m-warning': it.statusCode==='1', 'm-info': it.statusCode==='2', 'm-danger': it.statusCode==='3', 'm-primary': it.statusCode==='6'}"
                    >{{it.status}}</span>-->
                    <!-- <span class="m-assist fr">{{it.date}}</span> -->
                  </div>
                  <p class="m-des">请主管馆长姓名通知阅示</p>
                  <!-- <p class="m-assist" style="min-height:24px;">{{item.comment}}</p> -->
                </div>
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
      </el-form>
    </div>

    <div class="dialog-footer tr">
      <el-button
        type="primary"
        :loading="loadingSave"
        @click="submitForm('form')"
        >提交</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import cmpFormItem from '@cmp/form/item'
import cmpFormList from '@cmp/form/list'
import cmpLeaderList from '@cmp/leader-list'
import moment from 'moment'
export default {
  components: { cmpFormItem, cmpFormList, cmpLeaderList },
  data() {
    return {
      loadingSave: false,
      showLeaderPopover: false,
      defaultHeadImg: this.$store.state.app.defaultHeadImg,
      dialogShow: false,
      showPopover: false,
      configOptions: {
        startTime: {},
        endTime: {}
      },
      // 默认上下班时间
      configTime: {
        workTimeStart: '08:30', // 上班开始时间
        workTimeEnd: '17:30', // 上班结束时间
        overtimeStart: '08:00', // 加班开始时间
        overtimeEnd: '18:00' // 加班结束时间
      },
      configId: '', // 表单配置id
      renderData: '', // 表单data
      form: {
        currentApproval: '',
        ext1: ''
      },
      remoteFileList: [],
      approval: [], // 审批节点集合
      approverList: [], //审批人列表
      copytoList: [], //抄送人列表
      rules: {
        ext1: [{ required: true, message: '必填', trigger: 'blur' }],
        currentApproval: [{ required: true, message: '必填', trigger: 'change' }],
      },
      personList: []
    }
  },
  methods: {
    init(id) {
      this.dialogShow = true
      this.configId = id || ''

      // this.resetForm()
      this.getDataList()
    },
    getDict() {
      this.$http
        .post(`/collectDict/getSelectDataByArr`, {
          arr: ['document_type']
        })
        .then(res => {
          if (res.success) {
            let data = res.result.document_type
            console.log(222, data)
            data.forEach(item => {
              item.name = item.dictName
              item.value = item.dictCode
            })
            
            this.renderData.fields.forEach(item => {
              if(item.name === 'type') {
                item.options = data
              }
            })
            console.log(this.renderData)
          } else {
            this.$message.error(res.message)
          }
        })
    },
    getUserList() {
      this.$http
        .post(`/workflowConfig/copytoUserList`, {})
        .then(res => {
          if (res.success) {
            this.personList = res.result.userlist
          } else {
            this.$message.error(res.message)
          }
        })
    },
    getDataList(type, params) {
      // 1请假类型改变 2时长改变
      this.$http
        .get(`../${process.env.BASE_URL}test/gongwen.json`, {
        // .post('/workflowInst/form', {
        // .get(`../${process.env.BASE_URL}test/form-qjsq.json`, {
        // .get(`../${process.env.BASE_URL}test/form.json`, {
        // .get(`../${process.env.BASE_URL}test/form.1.json`, {
          // configId: this.configId,
          ...params
        })
        .then(res => {
          if (res.success) {
            let data = res.result
            console.log(11111, data)

            data.form.fields.forEach(item => {
              if(item.labelWidth) {
                item.labelWidth = item.labelWidth + 'px'
              }
            })
            data.form.detail.forEach(item => {
              if(item.labelWidth) {
                item.labelWidth = item.labelWidth + 'px'
              }
            })
            
            this.renderData = data.form
            this.form.key = data.form.key

            this.approval = data.approval

            // todo dele
            // this.approverList = data.approverList
            // this.copytoList = data.copytoList

            if (this.renderData.detail.length) {
              this.$nextTick(() => {
                this.$refs.cmpFormList.init()
              })
            }

            this.resetForm()
            // 复选框的情况、多选下拉框
            this.renderData.fields.forEach(item => {
              if(item.type === 'checkbox' || item.multiple) {
                this.$nextTick(() => {
                  this.$set(this.form, item.name, [])
                })
              }
            })
            // todo详情中复选框的情况
            // this.renderData.detail.forEach(item => {
            //   if(item.type === 'checkbox') {
            //     this.$nextTick(() => {
            //       this.$set(this.form, item.name, [])
            //     })
            //   }
            // })

            // this.resetForm()


            

            this.getDict()
            this.getUserList()
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 添加日历
    addDate(item) {
      console.log(item)
      let num = item.length + 1
      item.push({
        "name": "startTime_" + num,
        "ralationship": 'durationDay',
        "rules": [
          {
          "trigger": "blur",
          "message": "必填",
          "required": true
          }
        ],
        "label": "请假时间",
        // "label": "",
        // "labelWidth": "30px",
        "placeholder": "请选择",
        "type": "date"
      })
    },
    deleDate(item, index) {
      if(item.length > 1) {
        item.splice(index, 1)
      } else {
        this.$message.warning('至少保留一个请假时间')
      }
    },
    showLeaderList() {
      this.$refs.cmpLeaderList.showList(this.copytoList)
    },
    // 选择抄送人
    handleChooseAdd(item) {
      this.$set(item, 'canDele', true)
      this.copytoList.push(item)
      this.showPopover = false
    },
    // 设置总金额
    setCalc(name, total) {
      this.$set(this.form, name, total)

      // 金额改变、审批人改变
      this.getDataList('3', { holidayType: this.form.holidayType, totalAmount: this.form.totalAmount })
    },
    // 请假时长输入框改变
    eventChecker() {
      // 审批人改变
      this.getDataList('3', { ...this.form })
    },
    // 请假多选框 修改
    changeTimeMul() {
      console.log(this.form)
      // this.$set(this.form, 'durationDay', 3)
      // this.eventChangeTimeQJ()
    },
    // 请假申请类型改变
    changeHolidayType() {
      this.$nextTick(() => {
        this.$set(this.form, 'startTime', '')
        this.$set(this.form, 'endTime', '')
      })

      this.getDataList('1', { holidayType: this.form.holidayType })
    },
    // 请假时长修改重新拉取数据
    eventChangeTimeQJ() {
      if (this.form.key !== 'QJSQ') return

      this.getDataList('2', {...this.form})
      // if (this.form.holidayType === '0' || this.form.holidayType === '3') {
      //   this.getDataList('2', {
      //     holidayType: this.form.holidayType,
      //     startTime: this.form.startTime,
      //     endTime: this.form.endTime,
      //     snoon: this.form.snoon,
      //     enoon: this.form.enoon,
      //     durationDay: this.form.durationDay
      //   })
      // } else {
      //   this.getDataList('2', {
      //     holidayType: this.form.holidayType,
      //     startTime: this.form.startTime,
      //     endTime: this.form.endTime,
      //     durationHour: this.form.durationHour
      //   })
      // }
    },
    fujian(fileStr) {
      this.form.attId = fileStr
    },
    // 设为禁用或启用
    callFunDisable(aboutName, name) {
      this.renderData.fields.forEach(item => {
        if(item.name === aboutName) {
          this.$set(item, 'isDisable', this.form[name].length?true:false)
        }
      })
    },
    // 选择其他时出现文本框 将isHide改为false
    callFunOther(aboutName, name, val) {
      console.log(2334)
      this.renderData.fields.forEach(item => {
        if(item.name === aboutName) {
          this.$set(item, 'isHide', val)
        }
      })
    },
    // 删除抄送人
    dele(item, index) {
      this.copytoList.splice(index, 1)
    },
    submitForm(formName) {
      console.log('form', this.form)
      this.$refs[formName].validate(valid => {
        // 校验明细列表
        if (
          this.renderData.detail.length &&
          !this.$refs.cmpFormList.isValidate()
        ) {
          return
        }

        // 校验上部表单
        if (valid) {
          this.loadingSave = true
          this.$http
            .post('/document/bsDocumentInst/save', {
              ...this.form
            })
            .then(res => {
              this.loadingSave = false
              if (res.success) {
                // this.$message.success('发起' + this.renderData.name + '成功')
                // this.$store.dispatch('updataSiderbarCount')
                this.$message.success('发起流转成功')
                this.dialogShow = false
                this.$emit('refresh')
              } else {
                this.$message.error(res.message)
              }
            })
            .catch(() => {
              this.loadingSave = false
            })
        } else {
          return false
        }
      })
    },
    resetForm() {
      this.$nextTick(() => {
        this.remoteFileList = []
        this.form = {
          key: this.form.key,
          currentApproval: '',
          ext1: ''
        }
        this.$refs['form'].clearValidate()
        // this.$refs['form'].resetFields()
      })
    },
    handleBeforeClose(done) {
      this.resetForm()
      done()
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-leave-apply {
  .content {
    height: 700px;
    overflow-y: auto;
    padding-right: 10px;
  }

  .time-line-wrap {
    padding-top: 30px;
    border-bottom: solid 1px $border;
    .timeline-box {
      padding: 5px 0;
      display: flex;
      line-height: 24px;
      align-items: center;
      .timeline-content {
        padding-right: 20px;
        box-sizing: border-box;
        flex: 1;
        .name-box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 12px;
        }
        .m-des {
          font-size: 14px;
        }
      }
    }
  }

  .approve-list-person {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .person-box {
      position: relative;
      display: flex;
      align-items: center;
      &:first-child {
        .line {
          display: none;
        }
      }
      .line {
        width: 20px;
        height: 1px;
        background: $primary;
      }
    }
  }

  .operate {
    .svg-icon {
      vertical-align: middle;
    }
  }

  .el-icon-close {
    position: absolute;
    right: -7px;
    top: 0;
    color: #fff;
    background-color: $color6;
    padding: 2px;
    border-radius: 100%;
    cursor: pointer;
    font-size: 12px;
  }

  .date-list-box {
    .date-item {
      margin-bottom: 20px;
    }
    .close-box {
      position: absolute;
      top: 0;
      right: 0;
      // .el-icon-close {
      //   right: -30px;
      //   top: 10px;
      // }
    }
    .date-add {
      margin: 10px 30px;
    }
    /deep/ .el-form-item {
      margin-bottom: 0;
    }
  }


  .title {
    padding: 10px 0;
    border-bottom: solid 1px $border;
    &.noborder {
      margin-bottom: 0;
      border-bottom: none;
    }
  }
}
</style>
